// Constants
export const datos_proveedores_montura = () => {
  return {
    datos_proveedores_montura: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['proveedor_montura'],
        datatype: {
          predeterminate: ''
        }
      },
      name: {
        type: 'text',
        label: 'Nombre',
        dataform: ['proveedor_montura'],
        placeholder: '',
        description: 'nombre completo',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      documento: {
        type: 'number', 
        dataform: ['proveedor_montura'],
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: 'required|maxLength:15',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          append: '',
          prepend: '',
        }
      },   
      direccion: {
        type: 'text',
        label: 'Direccion',
        dataform: ['proveedor_montura'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',         
        }
      },  
      ciudad: {
        type: 'text',
        label: 'Ciudad',
        dataform: ['proveedor_montura'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      telefonos: {
        type: 'text',
        label: 'Teléfonos',
        dataform: ['proveedor_montura'],
        placeholder: '',
        description: 'No. de telefonos',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      email: {
        type: 'text',
        label: 'Email',
        dataform: ['proveedor_montura'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },   
    }    
  }
}

export function asign_datos_proveedores_montura(){
  var asign= Object.keys(datos_proveedores_montura().datos_proveedores_montura);
  var objeto = datos_proveedores_montura().datos_proveedores_montura
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}
